import type { FeatureSetting } from '@/features/feature-management/types/featureSetting';

export const DEFAULT_ENTERTAINMENT_FEATURE_VALUES: EntertainmentFeature['featureValues'] =
  {
    organizationId: undefined,
    startPageWebviewUrl: undefined,
    fullPageWebviewUrl: undefined
  };

export type EntertainmentFeature = Omit<FeatureSetting, 'featureValues'> & {
  featureValues: {
    organizationId?: string;
    startPageWebviewUrl?: string;
    fullPageWebviewUrl?: string;
  };
};
